<footer class="footer-wrapper">
  <div class="footer-content">
    <div class="footer-links">
      <a class="footer-link" [href]="'https://www.siemens.com'" target="_blank" rel="noopener noreferrer">
        © Siemens AG {{ currentYear }}
      </a>
      <a
        class="footer-link"
        [href]="'https://www.siemens.com/corp/en/index/corporate_info.htm'"
        [attr.aria-label]="'footer.corporateInformation' | translate"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ 'footer.corporateInformation' | translate }}
      </a>
      <a
        class="footer-link"
        [href]="'https://www.siemens.com/global/en/general/privacy-notice.html'"
        [attr.aria-label]="'footer.privacyNotice' | translate"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ 'footer.privacyNotice' | translate }}
      </a>
      <a
        class="footer-link"
        [href]="'https://www.siemens.com/global/en/general/cookie-notice.html'"
        [attr.aria-label]="'footer.cookieNotice' | translate"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ 'footer.cookieNotice' | translate }}
      </a>
      <a
        class="footer-link"
        [href]="'https://www.siemens.com/corp/en/index/terms_of_use.htm'"
        [attr.aria-label]="'footer.termsOfUse' | translate"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ 'footer.termsOfUse' | translate }}
      </a>
      <a
        class="footer-link"
        [href]="'https://www.siemens.com/global/en/general/digital-id.html'"
        [attr.aria-label]="'footer.digitalId' | translate"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ 'footer.digitalId' | translate }}
      </a>
    </div>
    <div class="footer-powered">
      <p>powered by <span class="footer-powered-bold">/GMS/</span></p>
    </div>
  </div>
</footer>
